$(document).ready(function () {
    if (document.URL.toLowerCase().indexOf("/institucional/gabinete-comunicacion/") > 0) {
        var language = document.URL.split('/')[3];

        $("#link_noticias").attr('href','/' + language + '/institucional/gabinete-comunicacion/noticias-ministerio');               
    }
});